// src/sim/ai/coordination/gaussian.ts — deterministic Box-Muller over any [0,1) RNG.
// Source: .planning/phases/04-ai/04-RESEARCH.md Pattern 7 + Wikipedia Box-Muller.
//
// gaussianPair(rng) consumes exactly 2 RNG draws per call and returns two
// independent N(0,1) samples. Deterministic: same rng state → same pair.
// Guard: u1 === 0 would produce log(0) = -Infinity; replaced with 1e-12.

/**
 * Box-Muller transform: returns two independent standard-normal (N(0,1)) samples.
 * Consumes exactly 2 draws from the provided [0,1) RNG per call.
 * Deterministic when called with the same rng state.
 */
export function gaussianPair(rng: () => number): [number, number] {
  let u1 = rng();
  if (u1 === 0) u1 = 1e-12; // guard: log(0) = -Infinity → NaN propagation
  const u2 = rng();
  const r = Math.sqrt(-2 * Math.log(u1));
  const theta = 2 * Math.PI * u2;
  return [r * Math.cos(theta), r * Math.sin(theta)];
}
